import React from 'react';
import '../App.css';
import {render} from 'react-dom';
import insta from './instapng.png';
import {ExternalLink} from 'react-external-link';

class TitleBar extends React.Component{
    constructor(props){
        super(props);
        this.menubar=this.menubar.bind(this);
        this.clickLoad=this.clickLoad.bind(this);
        this.state ={
            display: 'none',
        }
    }

    clickLoad(){
        let dis = this.state.display;
        if(dis=='none'){
            dis='block'
        }
        else{
            dis='none'
        }
        this.setState({display:dis});
        
    }

    menubar(){}
    render(){
        return(
            <>
                <div className="titleBar">
                    <h1  className="title">josh diesenhaus.</h1>
                    <div className="pages">
                        <ExternalLink href="http://joshdiesenhaus.com/about" className="page" ><h2>about.</h2></ExternalLink>
                        <ExternalLink href="http://joshdiesenhaus.com/design" className="page"><h2>design.</h2></ExternalLink>
                        <ExternalLink href="http://joshdiesenhaus.com/art" className="page"><h2>art.</h2></ExternalLink>
                        <ExternalLink href="http://joshdiesenhaus.com/engineering" className="page"><h2>engineering.</h2></ExternalLink>
                        <ExternalLink href="http://joshdiesenhaus.com/resume" className="page"><h2>resume.</h2></ExternalLink>
                        
                        {/* <img src={insta} alt="" style={{width:".1 rem",height:".1 rem"}}/> */}
                    </div>
                    <div className="buttonStyle" onClick={this.clickLoad}>
                        <div className="button">
                        </div>
                    </div>
                </div>
                <div className="underBar">
                    <h1 className="nm">underneath</h1>
                </div>
                <div className="vanish" style={{display:this.state.display}}>
                    <div className="smallMenu">
                        <ExternalLink className="page1" href= "http://joshdiesenhaus.com/about">about.</ExternalLink>
                        <ExternalLink className="page1" href= "http://joshdiesenhaus.com/design">design.</ExternalLink>
                        <ExternalLink className="page1" href= "http://joshdiesenhaus.com/art">art.</ExternalLink>
                        <ExternalLink className="page1" href= "http://joshdiesenhaus.com/design">engineering.</ExternalLink>
                        <ExternalLink className="page1" href= "http://joshdiesenhaus.com/resume">resume.</ExternalLink>
                    </div>
                </div>
            </>
        );
    }
}






export default TitleBar;